import React from 'react';
import WizardStepDefault from './WizardStepDefault';
import * as actions from '../../../store/actions/index';

const wizardStepFwk = (props) => {

  const getButtonsUrl = '/api/step_combinations/fwk?country=' + props.selectedSteps.country
  const onSelectAction = (stepValue) => { return actions.wizardSelectFwk(stepValue)}

  return(
    <WizardStepDefault
      stepName='fwk'
      getButtonsUrl={getButtonsUrl}
      onSelectAction={onSelectAction}
      currentStep={props.currentStep}
      dividerEnabled={true}
      modalTextToken={ 'wizard.steps.fwk.infotext' }
      />
 );

};

export default wizardStepFwk;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepFwk.js